<template>
  <generic-modal :title="$t('loan')" ref="generic_modal" :is_wide="true">
    <form>
      <generic-tabs
        ref="generic_tabs"
        :tabs="[
          {
            name: 'customer_info',
            label: $t('customer information'),
            icon: 'fa fa-user',
          },
          {
            name: 'credit_conditions',
            label: $t('credit conditions'),
            icon: 'fa fa-money',
          },
          {
            name: 'quotas_projection',
            label: $t('quotas'),
            icon: 'fa fa-table',
          },
        ]"
        orientation="horizontal"
      >
        <template v-slot:customer_info>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("first name") }}</label>
                <div class="control has-icons-left">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.customer.first_name"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-user"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("last name") }}</label>
                <div class="control has-icons-left">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.customer.last_name"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-user"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("birth date") }}</label>
                <div class="control has-icons-left">
                  <input
                    class="input"
                    type="date"
                    v-model="meta.customer.birth_date"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("email") }}</label>
                <div class="control has-icons-left">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.customer.email"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-envelope"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("phone") }}</label>
                <div class="control has-icons-left">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.customer.phone"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-phone"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("document type") }}</label>
                <div class="select is-fullwidth">
                  <select v-model="meta.customer.document_type">
                    <option value="" disabled>
                      {{ $t("select an option") }}
                    </option>
                    <option value="dpi">{{ $t("dpi") }}</option>
                    <option value="passport">{{ $t("passport") }}</option>
                    <option value="licencia">{{ $t("licence") }}</option>
                    <option value="partida">
                      {{ $t("birth certificate") }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("document number") }}</label>
                <div class="control has-icons-left">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.customer.document_number"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-id-card"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="columns" v-if="meta.customer.settings">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("zip code") }}</label>
                <div class="control has-icons-left">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.customer.applicant_zip_code"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-map-pin"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("state") }}</label>
                <div class="control has-icons-left">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.customer.settings.state"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-map-pin"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("city") }}</label>
                <div class="control has-icons-left">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.customer.settings.city"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-map-pin"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:credit_conditions>
          <div class="content">
            <div class="columns">
              <div class="column">
                <div class="field">
                  <generic-dropdown
                    :title="$t('credit type')"
                    :placeholder="$t('select one')"
                    :is_multiple="false"
                    url="/loan/loan-type/catalog"
                    name_field="name"
                    value_field="loan_type_id"
                    @selected="loan_type_changed"
                    ref="loan_type_dropdown"
                  />
                </div>
                <div class="field">
                  <label class="label">{{ $t("quotas") }}</label>
                  <div class="control">
                    <input
                      type="number"
                      class="input"
                      v-model="meta.credit.quotas"
                    />
                  </div>
                  <p class="help is-danger" v-if="!is_quotas_in_valid_range">
                    {{ $t("the number of quotas is out of the allowed range") }}
                    ({{ selected_type?.min_quotas }} -
                    {{ selected_type?.max_quotas }})
                  </p>
                </div>
                <div class="field">
                  <label class="label">{{ $t("late fee percentage") }}</label>
                  <div class="control">
                    <div class="field has-addons">
                      <div class="control is-expanded">
                        <input
                          type="number"
                          class="input"
                          v-model="meta.credit.late_fee_percentage"
                          step="0.01"
                        />
                      </div>
                      <div class="control">
                        <span class="button is-static">%</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field">
                  <label class="label">{{ $t("grace period days") }}</label>
                  <div class="control">
                    <input
                      type="number"
                      class="input"
                      v-model="meta.credit.grace_period_days"
                    />
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">{{ $t("amount") }}</label>
                  <div class="control">
                    <input
                      type="number"
                      class="input"
                      v-model="meta.credit.amount"
                    />
                  </div>
                  <p class="help is-danger" v-if="!is_amount_in_valid_range">
                    {{ $t("the amount is out of the allowed range") }} ({{
                      selected_type?.min_amount
                    }}
                    - {{ selected_type?.max_amount }})
                  </p>
                </div>
                <div class="field">
                  <label class="label"
                    >{{ $t("payment frequency") }}
                    <span class="has-text-danger">*</span></label
                  >
                  <div class="select is-fullwidth">
                    <select
                      v-model="meta.credit.payment_frequency"
                      :class="{ 'is-danger': !meta.credit.payment_frequency }"
                    >
                      <option value="" disabled>
                        {{ $t("select an option") }}
                      </option>
                      <option value="weekly">{{ $t("weekly") }}</option>
                      <option value="biweekly">{{ $t("biweekly") }}</option>
                      <option value="monthly">{{ $t("monthly") }}</option>
                    </select>
                  </div>
                </div>
                <div class="field">
                  <label class="label"
                    >{{ $t("interest rate") }}
                    <span class="has-text-danger">*</span></label
                  >
                  <div class="control">
                    <div class="field has-addons">
                      <div class="control is-expanded">
                        <input
                          type="number"
                          class="input"
                          v-model="meta.credit.interest_rate"
                          step="0.01"
                          :class="{ 'is-danger': !meta.credit.interest_rate }"
                        />
                      </div>
                      <div class="control">
                        <span class="button is-static">%</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field">
                  <label class="label"
                    >{{ $t("first payment date") }}
                    <span class="has-text-danger">*</span></label
                  >
                  <div class="control">
                    <div class="field">
                      <div class="control is-expanded">
                        <input
                          type="date"
                          class="input"
                          v-model="meta.credit.first_payment_date"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <pre>{{ meta }}</pre>
            <pre>{{ selected_type }}</pre>
            <pre>{{ application }}</pre> -->
          </div>
        </template>
        <template v-slot:quotas_projection>
          <!-- <div class="button" @click="calculate_quotas">
            <span class="icon">
              <i class="fa fa-calculator"></i>
            </span>
            <span>{{ $t("project quotas") }}</span>
          </div> -->

          <table class="table is-fullwidth is-striped is-hoverable">
            <thead>
              <tr>
                <th>{{ $t("number") }}</th>
                <th>{{ $t("due date") }}</th>
                <th>{{ $t("principal") }}</th>
                <th>{{ $t("interest") }}</th>
                <th>{{ $t("total") }}</th>
                <th>{{ $t("balance") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(quota, qidx) in meta.quotas" :key="qidx">
                <td>{{ quota.number }}</td>
                <td>{{ format_date(quota.due_date) }}</td>
                <td>{{ format_currency(quota.principal) }}</td>
                <td>{{ format_currency(quota.interest) }}</td>
                <td>{{ format_currency(quota.total) }}</td>
                <td>{{ format_currency(quota.balance) }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th colspan="2">{{ $t("totals") }}</th>
                <th>
                  {{
                    format_currency(
                      meta.quotas.reduce((sum, q) => sum + q.principal, 0)
                    )
                  }}
                </th>
                <th>
                  {{
                    format_currency(
                      meta.quotas.reduce((sum, q) => sum + q.interest, 0)
                    )
                  }}
                </th>
                <th>
                  {{
                    format_currency(
                      meta.quotas.reduce((sum, q) => sum + q.total, 0)
                    )
                  }}
                </th>
                <th></th>
              </tr>
            </tfoot>
          </table>
        </template>
      </generic-tabs>
    </form>

    <div class="notification is-danger" v-if="error" v-html="error"></div>

    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import GenericTabs from "@/components/generic_tabs/Index.vue";
import {
  generate_error_message_text,
  del,
  post,
  put,
  get,
  format_currency,
  format_date,
} from "@/utils";

export default {
  name: "LoanModal",
  components: { GenericModal, GenericDropdown, GenericTabs },
  data() {
    let v = this;
    return {
      loan: null,
      selected_type: null,
      meta: {
        customer: {},
        credit: {},
        quotas: [],
      },
      error: "",
      edit_mode: false,
    };
  },
  computed: {
    is_form_invalid() {
      return !this.meta.customer.first_name ||
        !this.meta.customer.last_name ||
        !this.meta.customer.phone ||
        !this.meta.credit.loan_type_id ||
        !this.meta.credit.amount ||
        !this.meta.credit.quotas ||
        !this.meta.credit.interest_rate ||
        !this.meta.credit.payment_frequency ||
        !this.meta.credit.first_payment_date ||
        !this.meta.quotas.length
        ? true
        : false;
    },
    is_amount_in_valid_range() {
      let v = this;
      if (
        v.selected_type &&
        v.meta.credit.amount >= v.selected_type.min_amount &&
        v.meta.credit.amount <= v.selected_type.max_amount
      ) {
        return true;
      }
      return false;
    },
    is_quotas_in_valid_range() {
      let v = this;
      if (
        v.selected_type &&
        v.meta.credit.quotas >= v.selected_type.min_quotas &&
        v.meta.credit.quotas <= v.selected_type.max_quotas
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    format_currency,
    format_date,
    show_modal(loan_uuid = null) {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
      // if (loan_uuid) {
      //   get("/loan/loan", { uuid: loan_uuid })
      //     .then((response) => {
      //       v.edit_mode = true;
      //       console.log(response);
      //       v.loan = response;
      //       // v.application = response;
      //       // v.meta = {
      //       //   customer: response.customer || {},
      //       //   credit: {
      //       //     amount: v.application.requested_amount,
      //       //   },
      //       //   // loan_application_id: v.application.loan_application_id,
      //       // };
      //     })
      //     .catch((error) => {
      //       v.error = generate_error_message_text(error);
      //     });
      // }
    },
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    save() {
      let v = this;
      if (v.is_form_invalid) return;

      let data = { ...v.meta };

      post("/loan/loan", { ...data })
        .then(() => {
          v.$emit("success");
          v.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.application = null;
      v.meta = {
        customer: {},
        credit: {},
        quotas: [],
      };
      v.selected_type = null;
      v.error = "";
      v.edit_mode = false;
      v.$refs.loan_type_dropdown.clear();
    },
    loan_type_changed(loan_type) {
      let v = this;
      if (loan_type) {
        v.selected_type = loan_type;
        v.meta.credit.loan_type_id = loan_type.loan_type_id;
        v.meta.credit.interest_rate = loan_type.interest_rate;
        v.meta.credit.grace_period_days = loan_type.grace_period_days;
        v.meta.credit.payment_frequency = loan_type.payment_frequency;
        v.meta.credit.late_fee_percentage = loan_type.late_fee_percentage;
      }
    },
    calculate_quotas() {
      let v = this;
      if (
        !v.meta.credit.quotas ||
        !v.meta.credit.amount ||
        !v.meta.credit.interest_rate ||
        !v.meta.credit.payment_frequency ||
        !v.meta.credit.first_payment_date
      ) {
        v.meta.quotas = [];
        return;
      }

      let arr = new Array(v.meta.credit.quotas).fill().map((_, i) => {
        return {
          number: i + 1,
          due_date: null,
          principal: 0,
          interest: 0,
          total: 0,
          balance: 0,
          is_paid: false,
        };
      });

      // Usar la fecha del primer pago como base
      let firstPaymentDate = new Date(v.meta.credit.first_payment_date);

      // Cálculo de cuota nivelada (French amortization)
      let principal = parseFloat(v.meta.credit.amount);
      let monthlyRate = parseFloat(v.meta.credit.interest_rate) / 100;
      let numberOfPayments = parseInt(v.meta.credit.quotas);

      // Ajustar la tasa según la frecuencia de pago
      let periodicRate = monthlyRate;
      if (v.meta.credit.payment_frequency === "weekly") {
        periodicRate = monthlyRate / 4.33; // Aproximadamente 4.33 semanas por mes
      } else if (v.meta.credit.payment_frequency === "biweekly") {
        periodicRate = monthlyRate / 2.17; // Aproximadamente 2.17 quincenas por mes
      }

      // Fórmula de cuota nivelada: PMT = P * [r(1+r)^n] / [(1+r)^n - 1]
      let levelPayment = 0;
      if (periodicRate > 0) {
        levelPayment =
          (principal *
            (periodicRate * Math.pow(1 + periodicRate, numberOfPayments))) /
          (Math.pow(1 + periodicRate, numberOfPayments) - 1);
      } else {
        // Si no hay interés, dividir el principal entre el número de cuotas
        levelPayment = principal / numberOfPayments;
      }

      let balance = principal;

      // Para quincenal, calcular el segundo día del mes (primer pago + 15 días)
      let secondBiweeklyDay = null;
      if (v.meta.credit.payment_frequency === "biweekly") {
        let tempDate = new Date(firstPaymentDate);
        tempDate.setDate(tempDate.getDate() + 15);
        secondBiweeklyDay = tempDate.getDate();
      }

      // Para semanal, calcular los 4 días fijos del mes
      let weeklyDays = [];
      if (v.meta.credit.payment_frequency === "weekly") {
        let tempDate = new Date(firstPaymentDate);
        for (let j = 0; j < 4; j++) {
          weeklyDays.push(tempDate.getDate());
          tempDate.setDate(tempDate.getDate() + 7);
        }
      }

      for (let i = 0; i < arr.length; i++) {
        let due_date = new Date();

        // Calcular fecha de vencimiento según la frecuencia
        if (v.meta.credit.payment_frequency === "monthly") {
          // Mensual: mismo día cada mes
          due_date = new Date(firstPaymentDate);
          due_date.setMonth(firstPaymentDate.getMonth() + i);
          // Manejar casos donde el día no existe en el mes destino (ej: 31 de febrero)
          if (due_date.getDate() !== firstPaymentDate.getDate()) {
            due_date.setDate(0); // Último día del mes anterior
          }
        } else if (v.meta.credit.payment_frequency === "biweekly") {
          // Quincenal: alternar entre dos días fijos cada mes
          let monthsToAdd = Math.floor(i / 2); // Cada 2 cuotas, avanzar un mes
          let isFirstDayOfMonth = i % 2 === 0; // Par = primer día, Impar = segundo día

          due_date = new Date(firstPaymentDate);
          due_date.setMonth(firstPaymentDate.getMonth() + monthsToAdd);

          if (isFirstDayOfMonth) {
            // Usar el día del primer pago
            due_date.setDate(firstPaymentDate.getDate());
          } else {
            // Usar el segundo día calculado
            due_date.setDate(secondBiweeklyDay);
          }

          // Manejar casos donde el día no existe en el mes destino
          let targetDay = isFirstDayOfMonth
            ? firstPaymentDate.getDate()
            : secondBiweeklyDay;
          let lastDayOfMonth = new Date(
            due_date.getFullYear(),
            due_date.getMonth() + 1,
            0
          ).getDate();
          if (targetDay > lastDayOfMonth) {
            due_date.setDate(lastDayOfMonth);
          }
        } else if (v.meta.credit.payment_frequency === "weekly") {
          // Semanal: rotar entre los mismos 4 días cada mes
          let monthsToAdd = Math.floor(i / 4); // Cada 4 cuotas, avanzar un mes
          let dayIndex = i % 4; // Índice del día dentro del mes (0, 1, 2, 3)

          due_date = new Date(firstPaymentDate);
          due_date.setMonth(firstPaymentDate.getMonth() + monthsToAdd);
          due_date.setDate(weeklyDays[dayIndex]);

          // Manejar casos donde el día no existe en el mes destino
          let targetDay = weeklyDays[dayIndex];
          let lastDayOfMonth = new Date(
            due_date.getFullYear(),
            due_date.getMonth() + 1,
            0
          ).getDate();
          if (targetDay > lastDayOfMonth) {
            due_date.setDate(lastDayOfMonth);
          }
        }

        // Calcular interés sobre el saldo pendiente
        let interest = balance * periodicRate;

        // El capital es la diferencia entre la cuota nivelada y el interés
        let principalPayment = levelPayment - interest;

        // Ajustar la última cuota para evitar diferencias por redondeo
        if (i === arr.length - 1) {
          principalPayment = balance;
          levelPayment = principalPayment + interest;
        }

        // Actualizar el saldo
        balance -= principalPayment;

        // Asignar valores al arreglo
        arr[i].due_date = due_date.toISOString().split("T")[0];
        arr[i].principal = Math.round(principalPayment * 100) / 100;
        arr[i].interest = Math.round(interest * 100) / 100;
        arr[i].total = Math.round(levelPayment * 100) / 100;
        arr[i].balance = Math.round(Math.max(0, balance) * 100) / 100;
      }

      v.meta.quotas = arr;
    },
  },
  watch: {
    "meta.credit.quotas": {
      handler() {
        this.calculate_quotas();
      },
      deep: true,
    },
    "meta.credit.amount": {
      handler() {
        this.calculate_quotas();
      },
      deep: true,
    },
    "meta.credit.payment_frequency": {
      handler() {
        this.calculate_quotas();
      },
      deep: true,
    },
    "meta.credit.interest_rate": {
      handler() {
        this.calculate_quotas();
      },
      deep: true,
    },
    "meta.credit.first_payment_date": {
      handler() {
        this.calculate_quotas();
      },
      deep: true,
    },
  },
};
</script>
